import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ExpandableMenuItem from 'tradera-components/site-header/dropdown-menu-item-expandable';
import { selectPreferredLanguage } from 'tradera-state/language/selectors';

import { LanguageSelect } from 'static/script/components/localization/language-select';
import TranslateIcon from '@tradera/blueprint/theme/icons2/translate.svg?jsx';
import { useTranslator } from 'tradera-lang/translate';
import { mapLanguageCodeToLanguageKey } from 'tradera-utils/map-language-code-to-language-key';

export const PlainLocalizationMenuItem = ({ onToggle, preferredLanguage }) => {
    const { t } = useTranslator();

    return (
        <ExpandableMenuItem
            label={t('siteheader_language', {
                language: t(
                    mapLanguageCodeToLanguageKey(
                        preferredLanguage.languageCodeIso2
                    )
                )
            })}
            className="site-dropdown__item-with-icon text-inter-medium site-dropdown__localization-menu-item"
            border
            icon={<TranslateIcon className="icon" />}
            onOpen={onToggle}
            onClose={onToggle}>
            <LanguageSelect inProfileMenu={true} />
        </ExpandableMenuItem>
    );
};

PlainLocalizationMenuItem.propTypes = {
    onToggle: PropTypes.func.isRequired,
    preferredLanguage: PropTypes.object
};

const mapStateToProps = state => ({
    preferredLanguage: selectPreferredLanguage(state)
});

export const LocalizationMenuItem = connect(mapStateToProps)(
    PlainLocalizationMenuItem
);
